<template>
  <div class="scc_modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content modal-content-donation-page">
        <div class="modal-body">
          <!--                                <p>You already have an appointment scheduled, please reschedule existing appointment.</p>-->
          <p>Minimum period of {{ blockedInformation.days }} days is required between appointments.</p>
          <p>You have an existing appointment scheduled:</p>
          <div class="info-block-blocked-section">
            <p class="p-blocked-section">{{ profileDonationData.name }}</p>
            <p class="p-blocked-section">{{ profileDonationData.address }}</p>
          </div>
          <div class="info-block-blocked-section">
            <p class="p-blocked-section"><span class="ph-blocked-section">Appointment Date:</span>{{ ' ' + blockedInformation.date }}</p>
            <p class="p-blocked-section"><span class="ph-blocked-section">Appointment Time:</span>{{ ' ' + blockedInformation.time }}</p>
            <!--        <p class="p-blocked-section"><span class="ph-blocked-section">Message:</span>{{ ' ' + blockedInformation.time }}</p>-->
          </div>
          <div id="row-button" class="row container-input-form container-input-form-right col-sm .container-button-confirm-right">
            <button
                class="button-section btn button-confirm"
                type="button"
                style="width: 70px"
                v-on:click="actionExit"
            >
              Exit
            </button>
            <button
                v-if = "blockedInformation.schedule"
                class="button-section btn button-confirm"
                type="button"
                v-on:click="actionReschedule"
            >
              <!-- v-on:click="openAppointment(blockedInformation.idProfile, userInformation.idDonor, false, '')"-->
              Reschedule
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "blockedWindow",
  // eslint-disable-next-line no-undef
  props: [ 'blockedInformation', 'profileDonationData'],
  mounted() {
  },
  methods:{
    actionReschedule(){
      this.$emit('actionBlocked', 'reschedule');
    },
    actionExit(){
      this.$emit('actionBlocked', 'exit');
    },
  }

}
</script>

<style scoped>
  #row-button{
    justify-content: center;
  }
  .button-confirm{
    display: block;
    text-align: center;
    min-width: 70px;
  }
</style>
